$.fn.equalizeColumnHeights = function () {
    const $columns = $(this).children('div[class^="col-"]');
    let highest = 0;

    //If there are no columns in this element, escape
    if (!$columns.length) return;

    //Get 'highest' column height
    $columns.each(() => {
        let $col = $(this);
        if ($col.height() > highest)
            highest = $col.height();
    })

    //Set all columns to 'highest' height
    $columns.height(highest);
};



// WEBPACK FOOTER //
// ./shared/scripts/equalizeColumnHeights.js